/*
 * @Description:
 * @Date: 2021-09-15 14:35:55
 */
// @ts-nocheck
Reflect.set(window, 'wx', require('weixin-js-sdk'));
import VConsole from 'vconsole';

import './public-path';
import { createApp } from 'vue';
import App from './App.vue';
// import store from './store'; // 需在router之前先引入，否则store中require.context会出问题：fn(path)可以获得，但里面的属性无法获取。
import { setupStore } from './store';
import router, { setupRouter } from './router';
import { setupGlobalComponents, setupDirectives } from '@/plugins';
import './assets/css/reset.css';
import 'xrk-components/lib/index.css';
/**
 * vant 样式文件
 */
import 'vant/lib/index.css';
const app = createApp(App);

setupStore(app);

setupRouter(app);

setupDirectives(app);
setupGlobalComponents(app);
setupDirectives(app);

process.env.NODE_ENV === 'development' && app.use(new VConsole());

router.isReady().then(() => app.mount('#app'));

window.rootV3Instance = app;
